// extracted by mini-css-extract-plugin
module.exports = {"home":"Resume_home__31SFc","center":"Resume_center__1_1QW"};